import { jwtDecode } from "jwt-decode"
import { getDoctorsList, getUser } from "../services/http-service/api"

export const ROLE_ADMIN = 0
export const ROLE_USER = 1
export const ROLE_DOCTOR = 2
export const ROLE_MANAGER = 3
export const ROLE_ENG = 4

export const getGender = (patient) => {
  return patient &&
    patient.profile &&
    (/^male$/i).test(patient.profile.data.gender)
    ? "Мужской"
    : patient &&
      patient.profile &&
      (/^female$/i).test(patient.profile.data.gender) ? "Женский" : ""
}

export const getUserFromToken = async (storedToken) => {
  const tokenData = storedToken && storedToken.split(" ", 2)
  if (tokenData && tokenData.length == 2) {
    const token = jwtDecode(tokenData[1])
    const roles = token.roles || [token.role]
    if (roles.includes(ROLE_DOCTOR)) {
      const doctors = await getDoctorsList()
      if (doctors.status == 200) {
        const doctor = doctors.data.find(d => d.userId === token.uid)
        return { ...token, roles, token: tokenData[1], id: token.uid, doctor: doctor }
      }
      if (doctors.status == 404) {
        // invalid token
        return null
      }
    }
    if (roles.includes(ROLE_USER)) {
      var user = await getUser(token.uid)
      var doctorId = +user.data.profile.data['doctor']
      const doctors = await getDoctorsList()
      if (doctors.status == 200) {
        const doctor = doctors.data.find(d => d.id === doctorId)
        return { ...token, roles, token: tokenData[1], user: user.data, doctor: doctor }
      }
      if (doctors.status == 404) {
        // invalid token
        return null
      }
    }
    return { ...token, roles, token: tokenData[1], isAdmin: roles.includes(ROLE_ADMIN) }
  }
  return null
}

export const patientsAreAnonymous = (visitor) => {
  return visitor && visitor.doctor && visitor.doctor.groups && visitor.doctor.groups.length > 0 && visitor.doctor.groups[0].profile.data['patients_are_anonymous']
}

export const patientsAreShared = (visitor) => {
  return visitor && visitor.doctor && visitor.doctor.groups && visitor.doctor.groups.length > 0 && visitor.doctor.groups[0].profile.data['patients_are_shared']
}

export const aiAllowed = (visitor, examType) => {
  return visitor && visitor.doctor && visitor.doctor.groups && visitor.doctor.groups.length > 0 && visitor.doctor.groups[0].profile.data['ai_allowed']
}

export const visitsEnabled = (visitor) => {
  return visitor && visitor.doctor && visitor.doctor.groups && visitor.doctor.groups.length > 0 && visitor.doctor.groups[0].profile.data['visits_enabled']
}

export const examStatus = (exam) => {
  let status = exam.profile?.data?.external_id ? "DAMUMED" : exam.status
  switch (status) {
    case 'OPEN':
      return exam.byDoctor ? "Назначено" : "Направлено доктору"
    case 'DAMUMED':
      return 'Направлено в Damumed'
    case 'CLOSED':
      return 'Получен'
    case 'ACTIVE':
      return 'Выполняется'
    case 'INACTIVE':
      return 'Пройдено'
    case 'UPLOADING':
      return 'В процессе выгрузки'
  }
}

export const aiStatus = (point) => {
  const pointData = JSON.parse(point && point.media?.profile?.data?.external_data2 || "{}")
  console.log('Point', pointData)
  const result = pointData.results?.find(result => result.filename == point.media.fileName)
  console.log('Result', result)
  return `AI-заключение: ${result ? 'получено' : 'не получено'}`
  /*
  const name = pointData.data && pointData.data.length > 0 && pointData.data[0].result.aiResult.probParams.class
      && pointData.data[0].result.aiResult.probParams.class.length > 0 ?
      pointData.data[0].result.aiResult.probParams.class[0].name : ""
  if (name === 'bad_endo') {
      return "AI заключение: не является эндоскопией уха"
  }
  if (name === 'nose') {
    return 'AI заключение: Риноскопия'
  }
  if (name === 'normal') {
    return 'AI заключение: 🟢 Нет патологии'
  }
  if (name === 'pathology') {
    return 'AI заключение: 🔴 Патология'
  }
  return `AI-заключение: ${name || 'не получено'}`
  */
}

const filterAIResults = (examTypeId, total, tags) => {
  if (total === 1) {
    return true
  }
  switch (examTypeId) {
    case 3:
      return tags.includes('Ухо')
    case 4:
      return tags.includes('Нос')
    default:
      return false
  }
}

export const parseAIResponse = (examTypeId, media) => {
  const fps = media.profile.data['frames'] / media.profile.data['length']
  const data = media.profile.data['external_data2'] && JSON.parse(media.profile.data['external_data2'])
  const info = data && data.results && data.results.length > 0 && data.results[0].results_info
  const status = info && info.results ? info.results
  .filter(r => filterAIResults(examTypeId, info.results.length, r.cascade ? Object.values(r.cascade) : []))
  .map(result => {
    const model = {
      model: `${result.model}`,
      tags: result.cascade ? Object.values(result.cascade).join(','): '',
      status: []
    }
    result.prediction_classes.map(prediction => {
      const start_time = Math.round(prediction.video_segments.start_frame / fps * 100) / 100
      const end_time = Math.round(prediction.video_segments.end_frame / fps * 100) / 100
      model.status.push({
        name: prediction.name,
        confidence: prediction.confidence,
        start: start_time,
        end: end_time
      })
    })
    return model
  }) : []
  return status
}
